import { useEffect } from 'react'
import { useAuth } from './useAuth'

/**
 * Hook to listen for 401 auth expired events
 * Automatically logs out user when token expires
 */
export function useAuthExpiry() {
  const { logout } = useAuth()

  useEffect(() => {
    const handleAuthExpired = () => {
      console.warn('Auth expired event received, logging out...')
      logout()
    }

    window.addEventListener('auth:expired', handleAuthExpired)
    return () => window.removeEventListener('auth:expired', handleAuthExpired)
  }, [logout])
}
